import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[belenderPageLayoutContent],belender-page-layout-content'
})
export class PageLayoutContentDirective {

  @HostBinding('class') hostClass = 'belender-page-layout-content';

  constructor() { }

}
